import React, { Fragment } from 'react';
import { ReactComponent as DisplayIcon } from 'assets/icons/dp.svg';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down.svg';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import { LogoutIcon } from 'cokitchen-icons';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { ReactComponent as TrashIcon } from 'assets/icons/trash-icon.svg';
import { PartnersIcon } from 'cokitchen-icons';
import useDashboardContext from 'contexts/dashboard.context';

const Profile = () => {
  const firstName = localStorage.getItem(STORAGE_KEYS.FIRST_NAME);
  const lastName = localStorage.getItem(STORAGE_KEYS.LAST_NAME);
  const navigate = useNavigate();
  const { setShowStudentAmbassadorModal } = useDashboardContext();

  const logout = () => {
    localStorage.clear();
    navigate(ROUTE_KEYS.LOGIN);
  };

  const list = [
    {
      name: 'Student Ambassador',
      icon: <PartnersIcon className='w-4 h-4' />,
      onclick: () => setShowStudentAmbassadorModal(true),
      iconColor: 'text-gray-4'
    },
    {
      name: 'trash',
      icon: <TrashIcon className='w-4 h-4' />,
      link: ROUTE_KEYS.TRASH,
      iconColor: 'text-gray-4'
    },
    {
      name: 'logout',
      onclick: logout,
      icon: <LogoutIcon className='w-4 h-4' />,
      styles: 'text-red-4'
    }
  ];

  return (
    <Dropdown
      placement='bottom'
      content={
        <div className='rounded-[40px] border px-2 md:px-4 py-2 flex gap-1 items-center border-gray-15'>
          <DisplayIcon className='max-sm:hidden text-[#707275]' />
          <span className='max-lg:hidden text-gray-6 max-w-[128px] truncate'>
            {firstName} {lastName}
          </span>
          <span className='lg:hidden text-gray-6'>
            {firstName?.[0]}
            {lastName?.[0]}
          </span>
          <ArrowDownIcon className='text-gray-8' />
        </div>
      }>
      <DropdownList>
        {list.map((item, i) => (
          <DropdownItem key={i} onClick={item.onclick} className={`${item?.styles} capitalize`}>
            {item.link ? (
              <Link to={item.link} className='flex items-center'>
                <span className={`pr-4 ${item?.iconColor}`}>{item?.icon}</span>
                {item.name}
              </Link>
            ) : (
              <Fragment>
                <span className={`pr-4 ${item?.iconColor}`}>{item?.icon}</span>
                {item.name}
              </Fragment>
            )}
          </DropdownItem>
        ))}
      </DropdownList>
    </Dropdown>
  );
};

export default Profile;
